  var sliders = document.querySelectorAll('.js-image-slider');

  sliders.forEach(function (slider) {
    new Swiper(slider, {
      loop: false,
      watchSlidesProgress: true,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets',
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      on: {
        slideChange: function () {
          this.pagination.render();
          this.pagination.update();
        }
      }
    });
  });